export default __webpack_public_path__ + "static/tatuananh-41cef261ffb3d25a5271c968f843c197.jpg";